import { styled, Checkbox as MuiCheckbox } from '@mui/material'
import { Z_INDEX_DEFAULT_VALUE } from 'redesign/shared/zIndex/constants'

export const FooterContainer = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
`

export const BodyContainer = styled('div')`
  display: flex;
  flex-direction: column;
`

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  width: 100%;
`

export const DrawerBody = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
  overflow-y: scroll;
`

export const DrawerFooter = styled('div')`
  display: flex;
  padding: ${({ theme }) => theme.spacing(2, 0)};
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  margin-top: auto;
  bottom: 0;
  background: ${({ theme }) => theme.palette.background.default};
  border-top: ${({ theme }) => `${theme.spacing(0.0625)} solid ${theme.palette.common?.cardBorder}`};
`

export const SearchbarContainer = styled('div')`
  padding: ${({ theme }) => theme.spacing(0, 2)};
  z-index: ${Z_INDEX_DEFAULT_VALUE};
`
export const DrawerContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hasButton' && prop !== 'reducedPadding',
})<{ hasButton?: boolean; reducedPadding?: boolean }>`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: ${({ theme, reducedPadding }) => theme.spacing(reducedPadding ? 1 : 3)};
  gap: ${({ hasButton, theme }) => theme.spacing(hasButton ? 2 : 3)};
  box-sizing: border-box;
  overflow: hidden;
`
export const Checkbox = styled(MuiCheckbox)`
  padding: 0;
  & > * {
    margin: 0;
  }
`

export const CardContainer = styled('div')`
  width: 100%;
  padding: ${({ theme }) => theme.spacing(2)};
  box-sizing: border-box;
  border-bottom: ${({ theme }) => `${theme.spacing(0.0625)} solid ${theme.palette.common?.divider}`};
  & > * {
    min-height: fit-content;
  }
`
